(function() {
  angular
    .module('cfn')
    .factory('personCoreDataResolver', personCoreDataResolver);

  personCoreDataResolver.$inject = ['Person'];
  // resolve function bef
  function personCoreDataResolver(Person) {
    return function() {
      return coreCommonResolveFunction(Person, true);
    };
  }
})();
